"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Light = void 0;
const moment_1 = __importDefault(require("moment"));
const Component_1 = require("./Component");
const ComponentType_1 = require("./ComponentType");
const ConfigPropField_1 = require("../config/ConfigPropField");
class Light extends Component_1.Component {
    constructor() {
        super(...arguments);
        this.on = false;
        this.level = 0;
        this.dimmable = false;
    }
    static fromConfig(configComponent) {
        const light = new Light(configComponent.id, ComponentType_1.ComponentType.LIGHT, configComponent.iid, moment_1.default());
        light.dimmable = (configComponent.props || ConfigPropField_1.ConfigPropField)[ConfigPropField_1.ConfigPropField.DIMMABLE];
        return light;
    }
    static turnOn() {
        return {
            intended: {
                s: { on: true, level: 100 },
            },
            futureReported: {
                s: { on: true, level: 100 },
            },
        };
    }
    static turnOff() {
        return {
            intended: {
                s: { on: false, level: 0 },
            },
            futureReported: {
                s: { on: false, level: 0 },
            },
        };
    }
    static toggle({ currentState }) {
        if (!currentState) {
            throw new Error('currentState was not provided.');
        }
        if (currentState.on) {
            return Light.turnOff();
        }
        return Light.turnOn();
    }
    static setToLevel({ values: { level } }) {
        if (typeof level !== 'number') {
            return {};
        }
        return {
            intended: {
                s: { on: level > 0, level },
            },
            futureReported: {
                s: { on: level > 0, level },
            },
        };
    }
}
exports.Light = Light;
//# sourceMappingURL=Light.js.map